import { AddPhotoAlternate, Twitter } from '@mui/icons-material'
import { Button, CircularProgress, Grid, IconButton, TextField } from '@mui/material'
import { useFormik } from 'formik'
import React, { useState } from 'react'
import CloseIcon from  '@mui/icons-material/Close'
import { uploadImageToCloudinary } from '../util/uploadToCloudinary'
import { useDispatch } from 'react-redux'
import { createRestaurant } from '../../component/State/Restaurant/Action'

const initialValues={
  name:"",
  description:"",
  cusineType:"",
  streetAddress:"",
  city:"",
  stateProvince:"",
  country:"",
  email:"",
  mobile:"",
  twitter:"",
  instagram:"",
  openingHours:"Mon-Sun : 9:00 AM - 12:00 PM",
  images:[]

}
const CreateRestaurantForm = () => {
  const dispatch=useDispatch();
  const [uploadImage,setUploadImage]=useState(false)
  const jwt=localStorage.getItem("jwt")
  const formik=useFormik({
    initialValues,
    onSubmit: (values)=>{
      const data={
        name:values.name,
        description:values.description,
        cusineType:values.cusineType,
        address:{
          streetAddress:values.streetAddress,
          city:values.city,
          stateProvince:values.stateProvince,
          postalCode:values.postalCode,
          country:values.country

        },
        contactInformation:{
          email:values.email,
        mobile:values.mobile,
        twitter:values.twitter,
        instagram:values.instagram,
        },
        openingHours:values.openingHours,
        images:values.images,

      }
      console.log("data ---",data);
      dispatch(createRestaurant({data,token:jwt}))


    }}
  )
  const handleImageChange= async (e)=>{
    const file=e.target.files[0]
    setUploadImage(true);
    const image = uploadImageToCloudinary(file);
    formik.setFieldValue("images",[...formik.values.images,image])
    setUploadImage(false)

  }
  const handleRemoveImage=(index)=>{
    const updatedImages=[...formik.values.images]
    updatedImages.splice(index,1);
    formik.setFieldValue("images",updatedImages)

  }
  return (
    <div className='py-10  lg:flex-col items-center justify-center min-h-screen'>
      <h1 className='font-bold  text-2xl text-center py-2'>
        Add New Restaurant
      </h1>
      <form onSubmit={formik.handleSubmit} className='space-y-4'>
        <Grid container spacing={2}>
          <Grid className="flex flex-wrap gap-5" item xs={12}>
            <input accept='image/*'
            style={{display:"none"}}
            onChange={handleImageChange}
            id="fileInput"
            type="file"
            />
            <label htmlFor='fileInput' className='relative'>
              <span className='w-24 h-24 cursor-pointer flex  items-center
               justify-center p-3 border rounded-md border-gray-600'>
                <AddPhotoAlternate className='text-white'/>
               </span>
               {
                uploadImage&& <div className='absolute right-0 top-0 left-0 bottom-0 w-24 h-24 flex justify-center items-center' >

                  <CircularProgress/>
                </div>
               }
            </label>
            <div className='flex flex-wrap gap-2'>
              {
                formik.values.images.map((image,index)=><div className='relative'>
                  <img src=" " 
                   className='w-24 h-24 object-cover'/>
                   <IconButton size="small"
                   sx={{
                    position: "absolute",
                    top:0,
                    right:0,
                    outline: "none"
                   }} onClick={handleRemoveImage(index)}>
                         <CloseIcon sx={{fontSize:"1rem"}}/>
                   </IconButton>
                </div>)
              }
            </div>
          </Grid>
          <Grid item xs={12}>
            <TextField fullWidth id="name"
            name="name"
            label="Name"
            variant="outlined"
            onChange={formik.handleChange}
            value={formik.values.name}>

            </TextField>

          </Grid>
          <Grid item xs={12}>
            <TextField fullWidth id="description"
            name="description"
            label="Description"
            variant="outlined"
            onChange={formik.handleChange}
            value={formik.values.description}>

            </TextField>

          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField fullWidth id="cusineType"
            name="cusineType"
            label="CusineType"
            variant="outlined"
            onChange={formik.handleChange}
            value={formik.values.cusineType}>

            </TextField>

          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField fullWidth id="openingHours"
            name="openingHours"
            label="openingHours"
            variant="outlined"
            onChange={formik.handleChange}
            value={formik.values.openingHours}>

            </TextField>

          </Grid>
          <Grid item xs={12}>
            <TextField fullWidth id="streetAddress"
            name="streetAddress"
            label="StreetAddress"
            variant="outlined"
            onChange={formik.handleChange}
            value={formik.values.streetAddress}>

            </TextField>

          </Grid>
          <Grid item xs={12}>
            <TextField fullWidth id="city"
            name="city"
            label="City"
            variant="outlined"
            onChange={formik.handleChange}
            value={formik.values.city}>

            </TextField>

          </Grid>
          <Grid item xs={12} lg={4}>
            <TextField fullWidth id="stateProvince"
            name="stateProvince"
            label="StateProvince"
            variant="outlined"
            onChange={formik.handleChange}
            value={formik.values.stateProvince}>

            </TextField>

          </Grid>
          <Grid item xs={12} lg={4}>
            <TextField fullWidth id="postalCode"
            name="postalCode"
            label="PostalCode"
            variant="outlined"
            onChange={formik.handleChange}
            value={formik.values.postalCode}>

            </TextField>

          </Grid>
          <Grid item xs={12} lg={4}>
            <TextField fullWidth id="country"
            name="country"
            label="Country"
            variant="outlined"
            oonChange={formik.handleChange}
            value={formik.values.country}>

            </TextField>

          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField fullWidth id="email"
            name="email"
            label="Email"
            variant="outlined"
            onChange={formik.handleChange}
            value={formik.values.email}>

            </TextField>

          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField fullWidth id="mobile"
            name="mobile"
            label="Mobile"
            variant="outlined"
            onChange={formik.handleChange}
            value={formik.values.mobile}>

            </TextField>

          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField fullWidth id="instagram"
            name="instagram"
            label="instagram"
            variant="outlined"
            onChange={formik.handleChange}
            value={formik.values.instagram}>

            </TextField>

          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField fullWidth id="twitter"
            name="twitter"
            label="Twitter"
            variant="outlined"
            onChange={formik.handleChange}
            value={formik.values.twitter}>

            </TextField>

          </Grid>

        </Grid>
        <Button  variant="contained" color="primary" type="submit">
          Create Restaurant
        </Button>

      </form>
    </div>
  )
}

export default CreateRestaurantForm